import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getTotalExternalRatingSummariesInfo, getRatingSummaryByType } from '@shared/utils/reviewsUtils';
import * as PropTypes from 'prop-types';
import { Text, mergeStyleSets } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
import { Constants } from '@shared/utils/constants';
import { RatingsInfo } from '@shared/components/ratings/ratingsInfo';
const contentStyles = mergeStyleSets({
    separator: {
        color: NeutralColors.gray90,
        margin: '0px 12px',
        fontSize: 18
    }
});
var HeaderRatingBarInfoKey = /*#__PURE__*/ function(HeaderRatingBarInfoKey) {
    HeaderRatingBarInfoKey["Internal"] = "internal";
    HeaderRatingBarInfoKey["External"] = "external";
    HeaderRatingBarInfoKey["All"] = "all";
    return HeaderRatingBarInfoKey;
}(HeaderRatingBarInfoKey || {});
export const AppDetailsHeaderRatingBar = ({ app }, context)=>{
    const allRatingSummaryObj = getRatingSummaryByType(app === null || app === void 0 ? void 0 : app.ratingSummaries, Constants.Reviews.ReviewsSource.All);
    const avgRating = (allRatingSummaryObj === null || allRatingSummaryObj === void 0 ? void 0 : allRatingSummaryObj.AverageRating) || app.AverageRating || 0;
    const ratingsCount = (allRatingSummaryObj === null || allRatingSummaryObj === void 0 ? void 0 : allRatingSummaryObj.TotalRatings) || app.NumberOfRatings || 0;
    const externalSummariesInfo = getTotalExternalRatingSummariesInfo(app.ratingSummaries);
    if (ratingsCount <= 0 && externalSummariesInfo.totalRatings <= 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        itemProp: "itemReviewed",
        itemScope: true,
        itemType: Constants.Reviews.Microdata.AppItemType,
        children: [
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "name",
                content: app.title
            }),
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "applicationCategory",
                content: Constants.Reviews.Microdata.AppCategory
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "appRatingCell",
                itemProp: "aggregateRating",
                itemScope: true,
                itemType: "https://schema.org/AggregateRating",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "detailsRating",
                            children: allRatingSummaryObj ? /*#__PURE__*/ _jsx(RatingsInfo, {
                                avgRating: avgRating,
                                ratingsCount: ratingsCount,
                                title: context.loc('Global_Loc_ratingsLower', 'ratings'),
                                context: context
                            }, "all") : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(RatingsInfo, {
                                        avgRating: avgRating,
                                        ratingsCount: ratingsCount,
                                        title: context.loc('RatingSummary_Title', 'Marketplace ratings'),
                                        context: context
                                    }, "internal"),
                                    externalSummariesInfo.totalRatings > 0 && /*#__PURE__*/ _jsx(Text, {
                                        className: contentStyles.separator,
                                        children: "|"
                                    }),
                                    externalSummariesInfo.totalRatings > 0 && /*#__PURE__*/ _jsx(RatingsInfo, {
                                        avgRating: externalSummariesInfo.averageRatings,
                                        ratingsCount: externalSummariesInfo.totalRatings,
                                        title: context.loc('appDetails_ExternalRatings', 'external ratings'),
                                        context: context
                                    }, "external")
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        itemProp: "reviewCount",
                        content: ratingsCount.toString()
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        itemProp: "ratingValue",
                        content: parseFloat(avgRating.toString()).toFixed(2)
                    })
                ]
            })
        ]
    });
};
AppDetailsHeaderRatingBar.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
